export function isProduction(): boolean {
  const fullHost = new URL(window?.location?.href ?? 'http://localhost').host;
  const host = fullHost.split('.').slice(-2).join('.');
  return host === 'dutchie.com';
}
